import { useState, useEffect, useRef,useCallback } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link as RouterLink, useNavigate, NavLink, useParams, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import imageCompression from 'browser-image-compression';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import pLimit from 'p-limit'; 
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';
import * as userActions from "../../actions/userActions";
import * as leadActions from "../../actions/leadActions";
// ----------------------------------------------------------------------
const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));
// ----------------------------------------------------------------------
const UploadDocument = (props) => {
  const { leadId, id } = useParams();
  const location = useLocation();
  const { actions, usersData, fetchLeadIdDocument, allLeadDocumentByLeadData } = props;
  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
  const navigate = useNavigate();
  const [allUsers, setAllUsers] = useState([]);
  const [selectedDocumentFiles, setSelectedDocumentFiles] = useState([]);
  const [getLeadId, setLeadId] = useState('');
  const [allUploadLeadDocument, setAllUploadLeadDocument] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const formRef = useRef(null);
  const [propLeadId, setPropLeadId] = useState('');
  const [allDocumentTypeData, setAllDocumentTypeData] = useState([]);
  const [open, setOpen] = useState(false);
  const [viewModalInfo, setViewModalInfo] = useState([]);
  const [isMobile, setIsMobile] = useState(null);
  const fileInputRef = useRef();
  const cameraInputRef = useRef();
  const [previews, setPreviews] = useState([]);
  const [compressedFiles, setCompressedFiles] = useState([]);
  const [imageDetails, setImageDetails] = useState([]);
  const [preloaderStatus, setPreloaderStatus] = useState(false);
  const [preloaderSubmitStatus, setPreloaderSubmitStatus] = useState(false);
  const [uploadProgressMap, setUploadProgressMap] = useState({});  // Tracks { filename: % }
  const [folderId, setFolderId] = useState(false);
  const [overlayState, setOverlayState] = useState({
    visible: false,
    total: 0,
    completed: 0,
    failedCount: 0,
    progressPercent: 0, // per-file progress
    message: '',
    retryFiles: []
  });

  useEffect(() => {
    // check user is logged-in or not
    const authToken = localStorage.getItem('authToken');
    if (authToken === null) {
      navigate('/login');
    }
    const obj = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestData = encryptData(obj);
    actions.usersData(requestData);
    if (usersData.success) {
      setAllUsers(usersData.data);
    }
  }, []);

  useEffect(() => {
    if (id !== undefined) {
      setFolderId(uuidv4());
      setPropLeadId(atob(id));
      setLeadId(propLeadId);
      const obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": atob(id) };
      // console.log("obj lead id- ", obj);
      const requestData = encryptData(obj);
      const response = actions.getUploadLeadDocument(requestData);
      response.then((result) => {
        // console.log("Promise resolved -  source data:", result); 
        if (result.data.success === 1) {
          const results = result.data.data.data;
          const resultArr = Object.keys(results).map((key) => results[key]);
          setAllUploadLeadDocument(resultArr);
        }
      }).catch((error) => {
        //  console.error("Promise rejected -  source data :", error); 
      });
    }
  }, [setAllUploadLeadDocument]);

  function isMobileDevice() {
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

  useEffect(() => {
    let obj = { 'start': '0', 'length': config.MAX_RECORDS };
    if (id !== undefined) {
      obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": atob(id) };
    }
    const requestData = encryptData(obj);
    const response = actions.masterDocumentTypeData(requestData, false);
    response.then((result) => {
      // console.log("Promise resolved -  source data:", result); 
      if (result.data.success === 1) {
        const results = result.data.data.data
        const filteredResultArr = results.filter((item) => item.status === "1");
        const sortedResultArr = filteredResultArr.sort((a, b) =>
          a.document_type.localeCompare(b.document_type)
        );
        setAllDocumentTypeData(sortedResultArr);
      }
    }).catch((error) => {
      //  console.error("Promise rejected -  source data :", error); 
    });
    const isMobileStatus = isMobileDevice();
    setIsMobile(isMobileStatus);
  }, [setAllDocumentTypeData]);

  useEffect(() => {
    return () => {
      imageDetails.forEach(img => {
        if (img.tempPreviewUrl) URL.revokeObjectURL(img.tempPreviewUrl);
        if (img.previewUrl) URL.revokeObjectURL(img.previewUrl);
      });
    };
  }, []);

  const handleDelete = (uidToDelete) => {
    setImageDetails(prevDetails => {
      const target = prevDetails.find(img => img.uid === uidToDelete);
      // 🧹 Revoke object URLs to prevent memory leaks
      if (target?.previewUrl) {
        URL.revokeObjectURL(target.previewUrl);
      }
      if (target?.tempPreviewUrl && target.tempPreviewUrl !== target.previewUrl) {
        URL.revokeObjectURL(target.tempPreviewUrl);
      }
      // 🧼 Filter out the deleted image
      const newDetails = prevDetails.filter(img => img.uid !== uidToDelete);
      // 🔄 Sync related states
      setPreviews(newDetails.map(img => img.previewUrl));
      setCompressedFiles(prev =>
        prev.filter(img => img.uid !== uidToDelete)
      );
      setSelectedDocumentFiles(prev =>
        prev.filter(img => img.uid !== uidToDelete)
      );
      setUploadProgressMap(prev => {
        const newMap = { ...prev };
        delete newMap[uidToDelete];
        return newMap;
      });
      return newDetails;
    });
  };

  const handleDocumentFileChange = (e) => {
      const files = Array.from(e.target.files);
      const base64Files = [];

      files.forEach((file) => {
          const reader = new FileReader();
          reader.onload = (event) => {
              const base64Data = event.target.result;
              const fileName = file.name;
              base64Files.push({  uid: uuidv4(), file: base64Data, name: fileName });
              if (base64Files.length === files.length) {
                  setSelectedDocumentFiles(base64Files);
              }
          };
          reader.readAsDataURL(file);
      });
  };

  const checkDocumentType = (data) => {
    return data.startsWith("dynamicDocument^");
  };

  const xhandleImageChange = async (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;
    const limit = pLimit(1);
    const options = {
      maxSizeMB: 1,
      useWebWorker: true,
      maxWidthOrHeight: 1024,
    };
    const fileUidMap = [];
    // Step 1: Add temporary placeholders and previews
    files.forEach((file) => {
      const uid = uuidv4();
      const tempUrl = URL.createObjectURL(file);
      fileUidMap.push({ uid, file });
      setImageDetails(prev => [
        ...prev,
        {
          uid,
          name: file.name,
          loading: true,
          tempPreviewUrl: tempUrl,
          previewUrl: tempUrl,
          rawFile: file,
        }
      ]);
      // Add placeholder for selectedDocumentFiles as well
      setSelectedDocumentFiles(prev => [
        ...prev,
        {
          uid,
          name: file.name,
          tempPath: null // Placeholder, will update after compression
        }
      ]);
    });

    const compressAndStore = async ({ uid, file }) => {
      try {
        const compressedFile = await imageCompression(file, options);
        const previewUrl = URL.createObjectURL(compressedFile);

        // Upload to server
        const formData = new FormData();
        formData.append('folderId', folderId);
        formData.append("file", compressedFile, file.name);
        formData.append("uid", uid);

        const result = await actions.uploadTempFile(formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          /* onUploadProgress: (event) => {
            const percent = Math.round((event.loaded * 100) / event.total);
            batch.forEach(f => {
              setUploadProgressMap(prev => ({ ...prev, [f.uid]: percent }));
            });
          } */
        });

        const { fileId, fileName, tempPath } = result.file;

        // Update imageDetails
        setImageDetails(prev =>
          prev.map(item =>
            item.uid === uid
              ? {
                ...item,
                compressedFile,
                previewUrl,
                loading: false,
                originalSize: (file.size / 1024).toFixed(2),
                compressedSize: (compressedFile.size / 1024).toFixed(2),
              }
              : item
          )
        );
        // console.log('result=' , result);
        // Update selectedDocumentFiles with compressed file
        setSelectedDocumentFiles(prev =>
          prev.map(item =>
            item.uid === uid
              ? { ...item,  tempPath }
              : item
          )
        );
       // console.log('selectedDocumentFiles=' , selectedDocumentFiles);
      } catch (err) {
        toast.error(`Compression failed for ${file.name}`);
      }
    };
    await Promise.all(fileUidMap.map(file => limit(() => compressAndStore(file))));
  };
 const options = { maxSizeMB: 1, useWebWorker: true, maxWidthOrHeight: 1024 };

// Reusable for retry
const compressAndStore = useCallback(
  async ({ uid, file }) => {
    try {
      setOverlayState(prev => ({ ...prev, message: `Compressing ${file.name}...` }));
      const compressedFile = await imageCompression(file, options);
      const previewUrl = URL.createObjectURL(compressedFile);

      setOverlayState(prev => ({ ...prev, message: `Uploading ${file.name}...` }));
      const formData = new FormData();
      formData.append("folderId", folderId);
      formData.append("file", compressedFile, file.name);
      formData.append("uid", uid);

      const result = await actions.uploadTempFile(formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: ev => {
          const percent = Math.round((ev.loaded * 100) / (ev.total || 1));
          setOverlayState(prev => ({ ...prev, progressPercent: percent }));
        }
      });

      const { tempPath } = result.file;

      setImageDetails(prev =>
        prev.map(item =>
          item.uid === uid
            ? {
                ...item,
                compressedFile,
                previewUrl,
                loading: false,
                originalSize: (file.size / 1024).toFixed(2),
                compressedSize: (compressedFile.size / 1024).toFixed(2)
              }
            : item
        )
      );

      setSelectedDocumentFiles(prev =>
        prev.map(item => (item.uid === uid ? { ...item, tempPath } : item))
      );

      setOverlayState(prev => ({
        ...prev,
        completed: Math.min(prev.completed + 1, prev.total),
        progressPercent: 0
      }));

      return { ok: true, uid };
    } catch (err) {
      setOverlayState(prev => ({
        ...prev,
        completed: Math.min(prev.completed + 1, prev.total),
        failedCount: prev.failedCount + 1
      }));
      return { ok: false, uid, file, error: err };
    }
  },
  [folderId, actions]
);

const handleImageChange = async event => {
  const files = Array.from(event.target.files || []);
  if (!files.length) return;

  const limit = pLimit(1);
  const fileUidMap = files.map(f => ({ uid: uuidv4(), file: f }));

  setOverlayState({
    visible: true,
    total: files.length,       // original total stays here
    completed: 0,              // start fresh
    failedCount: 0,
    progressPercent: 0,
    message: "Starting...",
    retryFiles: []
  });

  // placeholders
  fileUidMap.forEach(({ uid, file }) => {
    const tempUrl = URL.createObjectURL(file);
    setImageDetails(prev => [
      ...prev,
      { uid, name: file.name, loading: true, tempPreviewUrl: tempUrl, previewUrl: tempUrl, rawFile: file }
    ]);
    setSelectedDocumentFiles(prev => [...prev, { uid, name: file.name, tempPath: null }]);
  });

  const results = await Promise.all(fileUidMap.map(f => limit(() => compressAndStore(f))));
  const failed = results.filter(r => !r.ok).map(r => ({ uid: r.uid, file: r.file }));

  if (failed.length) {
    setOverlayState(prev => ({
      ...prev,
      message: `${failed.length} failed. Click retry.`,
      retryFiles: failed
    }));
  } else {
    setOverlayState(prev => ({ ...prev, message: "All files proccessed" }));
    setTimeout(() => {
                setOverlayState(o => ({ ...o, visible: false }));
            }, 500);
      }
};

const retryFailedUploads = async () => {
  const retryList = overlayState.retryFiles || [];
  if (!retryList.length) return;

  setOverlayState(prev => ({
    ...prev,
    message: "Retrying failed files...",
    failedCount: 0,
    progressPercent: 0,
    retryFiles: []
    // NOTICE: we do NOT reset `completed` here
  }));

  const limit = pLimit(1);
  const results = await Promise.all(retryList.map(f => limit(() => compressAndStore(f))));
  const stillFailed = results.filter(r => !r.ok);

  if (stillFailed.length) {
    setOverlayState(prev => ({
      ...prev,
      message: `${stillFailed.length} still failed`,
      retryFiles: stillFailed.map(s => ({ uid: s.uid, file: s.file })),
      failedCount: stillFailed.length
    }));
  } else {
    setOverlayState(prev => ({ ...prev, message: "Retry successful" }));
    setTimeout(() => {
                setOverlayState(o => ({ ...o, visible: false }));
            }, 500);
      }
};


  const onSubmit = async (data) => {
    setPropLeadId(atob(id));
    setLeadId(propLeadId);
    let documentTypeName = '';
    let documentTypeStatus = 'static';
    if (data.document_type !== undefined) {
      const docTypeOption = allDocumentTypeData.find(doc => doc.id === data.document_type);
      documentTypeName = docTypeOption ? docTypeOption.document_type : '';
      if (checkDocumentType(data.document_type)) {
        documentTypeStatus = 'dynamic';
      }
    }
    if (data.document_type.trim() === "") {
      toast.error("No document type has been selected.", { position: "top-right" });
      return;
    }
    if (!selectedDocumentFiles || selectedDocumentFiles.length === 0) {
      toast.error("No file has been selected.", { position: "top-right" });
      return;
    }
    if (data.document_note.trim() === "") {
      toast.error("Note is blank.", { position: "top-right" });
      return;
    }
    setPreloaderSubmitStatus(true);
    try {
      const params = {
        lead_id: propLeadId,
        document_type: data.document_type,
        document_note: data.document_note,
        document_file: selectedDocumentFiles,
        documentTypeName,
        documentTypeStatus,
        brief: "additional_documents",
      };

      const stop = 1;

      if (stop) {
            // console.log('params=', params);
            // return;
      }
      const requestData = encryptData(params);
      const response = await actions.addEditLeadDocument(requestData, navigate);
      if (response.data.success === 1) {
        toast.success(response.data.message, { position: "top-right" });
        const obj = { start: '0', length: config.MAX_RECORDS, lead_id: propLeadId };
        const fetchData = encryptData(obj);
        const res = await actions.getUploadLeadDocument(fetchData);
        if (res.data.success === 1) {
          const results = res.data.data.data;
          const resultArr = Object.keys(results).map((key) => results[key]);
          setAllUploadLeadDocument(resultArr);
        }
        reset();
        setSelectedDocumentFiles([]);
        setPreviews([]);
        setImageDetails([]);
        setUploadProgressMap({});
        props.updateParentState(false);
      } else {
        toast.error(response.data.message, { position: "top-right" });
      }
    } catch (error) {
      toast.error(error.toString(), { position: "top-right" });
    } finally {
      setPreloaderSubmitStatus(false);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const filteredItems = (allUploadLeadDocument ?? []).filter(item =>
    item.formatetdID.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.assignedUser.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.statusName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const startIndex = (currentPage - 1) * config.ITEMS_PER_PAGE;
  const endIndex = startIndex + config.ITEMS_PER_PAGE;
  const paginatedItems = filteredItems.slice(startIndex, endIndex);
  const totalPages = Math.ceil(filteredItems.length / config.ITEMS_PER_PAGE);
  const onRowClickAction = (itemObj, btnAction) => {
    setViewModalInfo(itemObj);
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <h5 className="fw-bold">Upload Document</h5>
      <div id="main-wrap" className='mt-4'>
        <div className="table-wrap">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>Document ID</th>
                <th>Created Date</th>
                <th>Document Type</th>
                <th>View Note</th>
                <th>View Document</th>
              </tr>
            </thead>
            {paginatedItems.length === 0 ? (
              <tbody>
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center' }}>
                    <h5>No Document</h5>
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {paginatedItems.map((item, index) => (
                  <tr key={index}>
                    <td>{item.formatetdID}</td>
                    <td>{item.created_date}</td>
                    <td>{item.documentTypeName}</td>
                    <td>
                      <RouterLink onClick={() => onRowClickAction(item)}><i className="bi bi-eye" /></RouterLink>
                    </td>
                    <td>
                      <a target="new" href={item.document} className='text-decoration-none'>
                        <i className="bi bi-eye" />
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
        <div>
          <nav className='mb-1'>
            <ul className="pagination pagination-md justify-content-end">
              {Array.from({ length: totalPages }, (_, index) => index + 1).map(page => (
                <li className="page-item">
                  <button
                    key={page}
                    onClick={() => handlePageChange(page)}
                    disabled={currentPage === page}
                    className="page-link"
                  >
                    {page}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
      <div id="main-wrap" className='mt-4'>
        <div className='row justify-content-between'>
          <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data" ref={formRef}>
            <div className="row guarantor" id="bank_statement-1">
              <div className='col-md-6'>
                <div className='form-group'>
                  <label htmlFor="document-type">
                    <span>Document Type <a style={{ color: "red" }}>*</a></span>
                    <select disabled={props.leadStatusFlag === true} id='document_type' className="form-select" name='document_type' {...register('document_type')}>
                      <option value="">Select Document Type</option>
                      {allDocumentTypeData.length > 0 && allDocumentTypeData.map((option) => (
                        <option value={option.id}>
                          {option.document_type}
                        </option>
                      ))}
                    </select>
                  </label>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='form-group'>
                  <label htmlFor="document_note">
                    <span>Notes <a style={{ color: "red" }}>*</a></span>
                    <textarea readOnly={props.leadStatusFlag === true}
                      id='document_note'
                      className='form-control'
                      placeholder="Type Something" {...register('document_note')}
                    />
                  </label>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="document_file">
                    <span>File Upload <a style={{ color: "red" }}>*</a></span>
                    <input disabled={props.leadStatusFlag === true} type='file' id='document_file' name='document_file' className='form-control' onChange={handleDocumentFileChange} />
                  </label>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', textAlign: 'center', margin: '20px 0' }}>
                  <hr style={{ flex: 1, border: 'none', borderTop: '1px solid' }} />
                  <span style={{ padding: '0 10px', color: '#888' }}>OR</span>
                  <hr style={{ flex: 1, border: 'none', borderTop: '1px solid' }} />
                </div>
                { /*  SAMPLE CODE  :  START */}
                <div style={{ paddingTop: "1px", paddingBottom: "10px" }} title={isMobile ? "Mobile" : "Laptop/Desktop"} >
                  <div style={{ display: 'flex', gap: '10px', marginBottom: 20 }}>
                    <button type="button" className="btn btn-warning" onClick={() => fileInputRef.current.click()}>Select Photos</button>
                    {isMobile && (
                      <button type="button" className="btn btn-success" onClick={() => cameraInputRef.current.click()}>Open Camera</button>)}
                    {preloaderStatus && (
                      <>
                        <div className="spinner-border small-preloader mt-2" role="status" >
                          <span className="visually-hidden">&nbsp;</span></div>
                      </>
                    )}
                  </div>
                  {/* Hidden file inputs */}
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleImageChange}
                  />
                  <input
                    type="file"
                    accept="image/*"
                    capture="environment"
                    multiple
                    ref={cameraInputRef}
                    style={{ display: 'none' }}
                    onChange={handleImageChange}
                  />
                  {/* Preview compressed images */}
                  
{overlayState.visible && (
        <div style={overlayStyles.container}>
          <div style={overlayStyles.box}>
            <button
              style={overlayStyles.closeBtn}
              onClick={() => setOverlayState(prev => ({ ...prev, visible: false }))}
            >
              ✕
            </button>
            <h4>File Compression Progress</h4>
            <p>{overlayState.message}</p>
            <p>
              {overlayState.completed}/{overlayState.total} processed
            </p>
            <progress
              value={overlayState.progressPercent}
              max="100"
              style={{ width: "100%" }}
            />
            {overlayState.failedCount > 0 && (
              <>
                <p style={{ color: "red" }}>
                  {overlayState.failedCount} failed
                </p>
                <button onClick={retryFailedUploads}>Retry Failed</button>
              </>
            )}
          </div>
        </div>
      )}
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px' }}>
                    {imageDetails.map((img) => (
                      <div key={img.uid} style={{ position: 'relative' }}>
                        <img
                          src={img.previewUrl || img.tempPreviewUrl}
                          alt={`preview-${img.uid}`}
                          style={{
                            width: '100%',
                            height: 80,
                            objectFit: 'cover',
                            borderRadius: 8,
                            opacity: img.loading ? 0.5 : 1,
                            transition: 'opacity 0.3s ease-in-out',
                          }}
                        />
                        {img.loading && (
                          <div style={{ marginTop: 6 }}>
                            <div
                              style={{
                                background: '#e0e0e0',
                                height: 6,
                                borderRadius: 3,
                                overflow: 'hidden',
                              }}
                            >
                              <div
                                style={{
                                  width: '100%',
                                  background: 'linear-gradient(90deg, #ccc 25%, #aaa 50%, #ccc 75%)',
                                  backgroundSize: '200% 100%',
                                  animation: 'loadingAnimation 1.5s infinite linear',
                                  height: '100%',
                                }}
                              />
                            </div>
                            <div style={{ fontSize: 10 }}>Compressing...</div>
                          </div>
                        )}
                        {!img.loading && (
                          <div style={{ fontSize: 12, marginTop: 6 }}>
                            Original: {img.originalSize} KB<br />
                            Compressed: {img.compressedSize} KB
                            {uploadProgressMap[img.uid] !== undefined && (
                              <div style={{ marginTop: 6 }}>
                                <div
                                  style={{
                                    background: '#e0e0e0',
                                    height: 6,
                                    borderRadius: 3,
                                    overflow: 'hidden',
                                  }}
                                >
                                  <div
                                    style={{
                                      width: `${uploadProgressMap[img.uid]}%`,
                                      background:
                                        uploadProgressMap[img.uid] < 100 ? '#007bff' : '#28a745',
                                      height: '100%',
                                      transition: 'width 0.3s',
                                    }}
                                  />
                                </div>
                                <div style={{ fontSize: 10 }}>
                                  {uploadProgressMap[img.uid] < 100
                                    ? `${uploadProgressMap[img.uid]}% uploading`
                                    : 'Uploaded'}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                        <button
                          aria-label="Delete image"
                          tabIndex={0}
                          onClick={() => handleDelete(img.uid)}
                          type="button"
                          style={{
                            position: 'absolute',
                            top: 2,
                            right: 2,
                            background: '#ff5555',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '50%',
                            width: 20,
                            height: 20,
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            lineHeight: '3px',
                          }}
                        >
                          ×
                        </button>
                      </div>
                    ))}
                    {/* Move this out to top-level in your component or in global CSS */}
                    <style>
                      {`
      @keyframes loadingAnimation {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
      }
    `}
                    </style>
                  </div>
                </div>
                { /*  SAMPLE CODE  :  END */}
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group mb-0">
                  {(props.userRoleType !== "Partner Logins" || props.leadFieldPermissions?.additional_documents?.add) && (
                    <button
                        type="submit"
                        disabled={props.leadStatusFlag === true}
                        className="btn btn-primary"
                    >
                        Submit
                    </button>
                )}
                </div>
                {preloaderSubmitStatus && (
                  <>
                    <div className="spinner-border small-preloader mt-2" role="status" >
                      <span className="visually-hidden">&nbsp;</span></div>
                  </>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <div className='modal-custom rounded'>
          <div className='modal-head'>
            <h4 id="modal-title">Lead Document</h4>
          </div>
          <div className='modal-body'>
            <div className='row mb-2 pb-1'>
              <div className='col-1'>&nbsp;</div>
              <div className='col-10 ps-0'>{viewModalInfo.note}</div>
            </div>
          </div>
        </div>
      </Modal>
      

    </>
  );
}

function mapStateToProps(state) {
  return {
    usersData: state.usersData,
    getUserModuleData: state.getUserModuleData,
    getUploadLeadDocument: state.getUploadLeadDocument,
    masterDocumentTypeData: state.masterDocumentTypeData,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(userActions.default, leadActions.default), dispatch),
  }
}

const overlayStyles = {
  container: {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    fontSize: "12px",
  },
  box: {
    background: "#fff",
    padding: "20px",
    borderRadius: "8px",
    width: "350px",
    textAlign: "center",
    position: "relative"
  },
  closeBtn: {
    position: "absolute",
    top: "5px",
    right: "10px",
    border: "none",
    background: "transparent",
    fontSize: "20px",
    cursor: "pointer"
  }
};
export default connect(mapStateToProps, mapDispatchToProps)(UploadDocument);
